/**
 * When overlapping HTTP requests abort earlier ones (see baseListService AbortController),
 * `finally { loading = false }` from the aborted call must not clear loading while a newer call is still in flight.
 */

export function createLoadingGenerationTracker() {
    let generation = 0;

    return {
        next(): number {
            return ++generation;
        },
        isLatest(id: number): boolean {
            return id === generation;
        },
    };
}

export function createKeyedLoadingGenerationTracker() {
    const generations = new Map<string, number>();

    return {
        next(key: string): number {
            const n = (generations.get(key) ?? 0) + 1;
            generations.set(key, n);
            return n;
        },
        isLatest(key: string, id: number): boolean {
            return generations.get(key) === id;
        },
    };
}
